import { useContext, useEffect, useState } from 'react';

import moment from 'jalali-moment';
/** @format */
import { Link, useParams } from 'react-router-dom';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { checkLogin } from '../../Shared/hooks/authenticate';
import { canSelfRegisterOnEvent, htmlToJsx } from '../../Shared/utils/helper';
import { useRole } from '../../Shared/hooks/CustomHooks';
import Master from '../Layouts/Master';

const Event = () => {
  const { id } = useParams();
  const { can, canBoard } = useRole();

  const eventContext = useContext(EventContext);
  const [loading, setLoading] = useState(false);
  const [checkCanEdit, setCheckCanEdit] = useState(false);

  useEffect(() => {
    const getInfo = async () => {
      setLoading(true);
      await useApi.get(
        `/event/${id}`,
        {},
        (res) => {
          let data = res.data.data;
          if (!data?.users) {
            data.users = [];
          }
          eventContext.event = data;
          setLoading(false);
        },
        (err) => {
          error('هنگام دریافت اطلاعات خطایی رخ داده است');
          setLoading(false);
        },
      );
    };
    const cehckCanEditProvinces = async () => {
      setLoading(true);
      await useApi.get(
        `/user/check/access-edit/event/${id}`,
        {},
        (res) => {
          setCheckCanEdit(res.data?.data?.canEdit);
          setLoading(false);
        },
        (err) => {
          error('هنگام دریافت اطلاعات خطایی رخ داده است');
          setLoading(false);
        },
      );
    };
    getInfo();
    if (checkLogin()) {
      cehckCanEditProvinces();
    }
  }, [id]);

  return loading ? (
    <Loading />
  ) : (
    <Master
      showSidebar={false}
      containerFullWidth={true}
      headerFixed={true}
      title={`ثبت نام | ${eventContext.event?.title} `}
    >
      <div className='image-cover'>
        <div className='home-back-img w-100 d-flex flex-column'>
          <div className='row mx-2 my-4'>
            <div className='col-12 overflow-hidden mx-0 px-0'>
              <div className='card card-hover border rounded overflow-hidden position-relative'>
                <div className='bg-purple w-100 p-4 d-flex flex-row justify-content-center'>
                  <span className='text-dark-mode f-14 font-weight-bold'>
                    {eventContext.event.title}
                  </span>
                </div>
                <div className='card-body p-0 d-flex flex-column justify-content-center w-100 align-items-center'>
                  <div className='d-flex flex-column p-2 justify-content-center w-100 align-items-start'>
                    {eventContext.event?.place !== undefined &&
                    eventContext.event?.place != null ? (
                      <span className='f-14 my-2'>
                        مکان : {eventContext.event.place}
                      </span>
                    ) : (
                      ''
                    )}
                    <span className='f-14'>
                      زمان : {eventContext.event.time}
                    </span>
                    <div className='d-flex flex-row'>
                      <span className='f-14'>تاریخ شروع ثبت نام </span>
                      <span className='mx-2'>
                        {moment(
                          eventContext?.event?.start_register_date ??
                            '1999-09-09 09:09:09',
                          'YYYY-MM-DD HH:mm:ss',
                        )
                          .locale('fa')
                          .format('YYYY/MM/DD')}
                      </span>
                    </div>
                    <div className='d-flex flex-row'>
                      <span className='f-14'>تاریخ پایان ثبت نام </span>
                      <span className='mx-2'>
                        {moment(
                          eventContext.event?.end_register_date ??
                            '1999-09-09 09:09:09',
                          'YYYY-MM-DD HH:mm:ss',
                        )
                          .locale('fa')
                          .format('YYYY/MM/DD')}
                      </span>
                    </div>
                    <div className='row w-100 overflow-auto'>
                      <div className='col-12'>
                        {htmlToJsx(eventContext.event.description ?? '')}
                      </div>
                    </div>

                    {moment()
                      .locale('fa')
                      .isBefore(
                        moment(
                          eventContext.event?.end_register_date ??
                            '1999-01-01 00:00:00',
                          'YYYY-MM-DD HH:mm:ss',
                        ),
                      ) &&
                    moment()
                      .locale('fa')
                      .isAfter(
                        moment(
                          eventContext.event?.start_register_date ??
                            '1999-01-01 00:00:00',
                          'YYYY-MM-DD HH:mm:ss',
                        ),
                      ) &&
                    (eventContext.event.capacity == null ||
                      eventContext.event.capacity >
                        eventContext.event?.users_count) &&
                    canSelfRegisterOnEvent(eventContext.event, {
                      can,
                      canBoard,
                    }) ? (
                      <Link
                        to={
                          eventContext.event.step_eventing == 0
                            ? `/event/register/${eventContext.event.id}`
                            : `/event/show/${eventContext.event.id}/gender`
                        }
                        className='btn btn-danger mx-auto my-3'
                      >
                        <i className='fad fa-user-plus text-dark-mode f-18 mx-2'></i>
                        ثبت نام
                      </Link>
                    ) : checkCanEdit &&
                      canSelfRegisterOnEvent(eventContext.event, {
                        can,
                        canBoard,
                      }) ? (
                      <Link
                        to={
                          eventContext.event.step_eventing == 0
                            ? `/event/register/${eventContext.event.id}`
                            : `/event/show/${eventContext.event.id}/gender`
                        }
                        className='btn btn-danger mx-auto my-3'
                      >
                        <i className='fad fa-user-plus text-dark-mode f-18 mx-2'></i>
                        ثبت نام
                      </Link>
                    ) : null}

                    {/*can('Temporary Registrant') && id == 5 ? (
											<Link
												to={
													eventContext.event.step_eventing == 0
														? `/event/register/${eventContext.event.id}`
														: `/event/show/${eventContext.event.id}/gender`
												}
												className='btn btn-danger mx-auto my-3'>
												<i className='fad fa-user-plus text-dark-mode f-18 mx-2'></i>
												ثبت نام
											</Link>
											) : null*/}
                  </div>

                  <div className='d-flex flex-row justify-content-center  w-100 p-2'></div>
                </div>
              </div>
              <div className='overflow-hidden card-event-label'>
                {moment()
                  .local('fa')
                  .isAfter(
                    moment(
                      eventContext.event?.end_register_date,
                      'YYYY-MM-DD HH:mm:ss',
                    ),
                  ) ? (
                  <>
                    <span className='bg-success text-dark-mode f-12 font-weight-bold'>
                      پایان ثبت نام
                    </span>
                  </>
                ) : (
                  <>
                    {eventContext.event.capacity != null &&
                    eventContext.event.capacity <=
                      eventContext.event?.users?.length ? (
                      <span className='bg-danger text-dark-mode f-12 font-weight-bold'>
                        ظرفیت تکمیل
                      </span>
                    ) : null}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Master>
  );
};

export default Event;
